import { ReactNode } from 'react';
import {
  Box,
  CSSObject,
  Flex,
  Stat,
  StatLabel,
  StatNumber,
  StatProps,
  useColorModeValue,
  useMultiStyleConfig,
} from '@chakra-ui/react';

export interface SummaryCardProps {
  variant?: 'outline' | 'solid' | 'ghost';
  title: string;
  secondaryTitle?: string | ReactNode;
  details?: ReactNode;
  icon?: ReactNode;
  iconsBackground?: string;
  footer?: ReactNode;
  containerProps?: CSSObject;
  statContainerProps?: CSSObject;
  statProps?: StatProps;
  titleProps?: CSSObject;
  secondaryTitleProps?: CSSObject;
  detailsProps?: CSSObject;
  footerProps?: CSSObject;
  iconProps?: CSSObject;
}

export const SummaryCard = (props: SummaryCardProps) => {
  const {
    title,
    secondaryTitle,
    details,
    icon,
    iconsBackground,
    footer,
    variant = 'solid',
    containerProps,
    statContainerProps,
    statProps,
    titleProps,
    secondaryTitleProps,
    detailsProps,
    footerProps,
    iconProps,
  } = props;
  const iconsBg = useColorModeValue(iconsBackground, iconsBackground);
  const styles = useMultiStyleConfig(`SummaryCard`, {
    variant,
  });

  return (
    <Flex sx={{ ...styles.container, ...containerProps }}>
      <Flex sx={{ ...styles.statcontainer, ...statContainerProps }}>
        <Stat {...statProps}>
          <StatLabel sx={{ ...styles.title, ...titleProps }}>{title}</StatLabel>
          <StatLabel sx={{ ...styles.secondarytitle, ...secondaryTitleProps }}>
            {secondaryTitle}
          </StatLabel>
          <StatNumber sx={{ ...styles.details, ...detailsProps }}>
            {details}
          </StatNumber>
          <Box sx={{ ...footerProps }}>{footer}</Box>
        </Stat>
      </Flex>
      {icon && (
        <Box bg={iconsBg} sx={{ ...styles.icon, ...iconProps }}>
          {icon}
        </Box>
      )}
    </Flex>
  );
};
